import { useQuery } from '@tanstack/react-query';
import { queryKeys } from './queryKeys';

import { getCitiesMunicipalitiesApi, cityListApi } from '../services/apiService'

export function useCitiesMunicipalities(options = {}) {
    return useQuery({
        queryKey: queryKeys.locations.citiesMunicipalities(),
        queryFn: async ({ signal }) => {
            const res = await getCitiesMunicipalitiesApi({ signal });

            return res?.data?.data ?? [];

        },
        staleTime: 24 * 60 * 60 * 1000,
        gcTime: 24 * 60 * 60 * 1000,
        meta: {
            persist: true,
        },
        ...options,
    });
}

export function useCities(options = {}) {
    return useQuery({
        queryKey: queryKeys.locations.cities(),
        queryFn: async ({ signal }) => {
            const res = await cityListApi({ signal });

            return Array.isArray(res?.data?.data) ? res.data.data : [];
        },
        staleTime: 24 * 60 * 60 * 1000,
        gcTime: 24 * 60 * 60 * 1000,
        meta: {
            persist: true,
        },
        ...options,
    });
}